/**
 * Sign-up page
 * initial it by passing sign-up form ID
 **/
import FormMessageHandler from './formMessageHandler';
import Recaptcha from "./recaptcha";
import Mixpanel from "../modules/mixpanel";

let Spinner = require('spin');
let cacoo = require('../components/cacoo').cacoo;

/**
 * Options properties:
 *    - noEmailExistValidation: Check the email exists in the database
 * Sign-up success and failure callback
 *    - signup.submitForm(context, success, fail)
 */
export default class Signup {
  constructor(formId, options = {}) {
    this.body = $('body');
    this.form = $('form#' + formId, this.body);
    this.mail = $("input#email", this.form);
    this.fullName = $("input#name", this.form);
    this.password = $("input#password", this.form);
    this.tos = $('input#privacyAgree', this.form);
    this.privacy = $('input#privacyPolicy', this.form);
    this.privacyError = $('#privacyPolicyError', this.form);
    this.tosError = $('#agreeError', this.form);
    this.next = $('input[name="next"]', this.form);
    this.recaptchaToken = $('input[name="recaptchaToken"]', this.form);
    this.recaptchaError = $('.error-message.recaptcha', this.form);
    this.submitButton = $('button[type="submit"]', this.form);
    this.email = undefined;
    this.formMessageHandler = new FormMessageHandler(this.form);
    this.buttonSpinner = new Spinner({color: '#fff', lines: 12});
    this.recaptcha = new Recaptcha(this.recaptchaToken);
    this.existingAccountLink = $('#existingAccountSignupLink')
    this.planSelect = $('#planKey', this.form)
    this.planKey = this.planSelect.val()

    this.recaptchaError.html(Cacoo.SiteResources.recaptcha_error);

    this.options = options || {};
    this.attachEvent();

    const signinLink = `${Cacoo.settings.nulabAccountBaseUrl}/spaces/new?plan_key=${this.planKey ? this.planKey : 'cacoo.team.trial'}&redirect_uri=${Cacoo.settings.baseUrl}/ext/v2/signup/connect/complete&send_email=true&lang=${Cacoo.settings.lang}`
    let signin = `${Cacoo.settings.nulabAccountBaseUrl}/signin?existing_flow_product=cacoo&redirect_uri=${encodeURIComponent(signinLink)}`
    this.existingAccountSignupUrl = `${Cacoo.settings.nulabAccountBaseUrl}/signout?redirect_uri=${encodeURIComponent(signin)}`

    if (this.existingAccountLink) {
      this.existingAccountLink.attr('href', this.existingAccountSignupUrl)
      this.existingAccountLink.on('click', () => {
        mixpanel.track('Clicked on signup existing account')
      })
    }
  }

  attachEvent() {
    this.mail.on('focusout', () => {
      this.mailValidate();
    });

    this.fullName.on('focusout', () => {
      this.nameValidate();
      if (cacoo.util.validateEmail(this.fullName.val())) {
        this.formMessageHandler.showError('name', Cacoo.SiteResources['modal_signup_name_error']);
      }
    });

    this.password.on('focusout', () => {
      this.passwordValidate();
    });

    //Only for Japanese version
    if (this.tos.length > 0) {
      this.tos.on('click', () => {
        this.tosError.hide();
      });
    }

    if (this.privacy.length > 0) {
      this.privacy.on('click', () => {
        this.privacyError.hide();
      })
    }
  }

  mailValidate() {
    //If the email isn't change at all, doesn't need to validate again
    if (this.email != undefined && this.email === this.mail.val()) {
      return false;
    }

    this.email = this.mail.val();

    if (!cacoo.util.validateEmail(this.email)) {
      this.formMessageHandler.showError('email', Cacoo.SiteResources['modal_signup_email_error']);
      return false;
    }

    if (!this.options.noEmailExistValidation) {
      this.checkEmailExists(this.email);
    } else {
      this.formMessageHandler.showSuccess(['email']);
    }

  }

  checkEmailExists(email) {
    cacoo.util.checkEmailExists(email).then((data) => {
      this.checkEmailExists_load(data);
    })
  }

  checkEmailExists_load(data) {
    data = data || {};
    if ((data.existsInCacoo && data.existsInNulab) || (data.existsInCacoo && !data.existsInNulab)) {
      let errorMessage = cacoo.util.getResourceWithArg(Cacoo.SiteResources['modal_signup_email_registered_Nulab'], [this.existingAccountSignupUrl]);
      this.formMessageHandler.showError('email', errorMessage);
    } else if (!data.existsInCacoo && data.existsInNulab) {
      let errorMessage = cacoo.util.getResourceWithArg(Cacoo.SiteResources['modal_signup_email_registered_Nulab'], [Cacoo.settings.appBaseUrl + "/signin/nulab"]);
      this.formMessageHandler.showError('email', errorMessage);
    } else {
      this.formMessageHandler.showSuccess(['email']);
    }
  }

  nameValidate() {
    if (this.fullName.val().length > 0) {
      this.formMessageHandler.showSuccess(['name']);
      return true;
    }
    this.formMessageHandler.showError('name', Cacoo.SiteResources['modal_signup_name_error']);
    return false;

  }

  passwordValidate() {
    if (this.password.val().length > 7 && this.password.val().length < 200) {
      this.formMessageHandler.showSuccess(['password']);
    } else {
      this.formMessageHandler.showError('password', Cacoo.SiteResources['modal_signup_password_error']);
    }
  }

  tosValidate() {
    if (this.tos.length > 0 && !this.tos.is(":checked")) {
      this.tosError.show();
    }
  }

  privacyValidate() {
    if (this.privacy.length > 0 && !this.privacy.is(":checked")) {
      this.privacyError.show();
    }
  }

  finalValidate(noEmailValidation = false) {
    if(this.form.attr("data-signed") !== undefined) {
      return true;
    }

    if(!noEmailValidation) {
      this.mailValidate();
    }
    this.nameValidate();
    this.passwordValidate();
    this.tosValidate();
    this.privacyValidate();

    if(!noEmailValidation && !this.mail.hasClass("is_success")) {
      return false;
    }

    return (
      this.fullName.hasClass("is_success") &&
      this.password.hasClass("is_success") &&
      (this.tos.length === 0 || this.tos.is(":checked")) &&
      (this.privacy.length === 0 || this.privacy.is(":checked"))
    );
  }

  getFormData() {
    let formData = (this.form.serializeArray());
    let formJSON = {};
    $.each(formData, function (i, d) {
      formJSON[d.name] = d.value;
    });
    if (mixpanel.nulab && mixpanel.nulab.get_distinct_id) {
      formJSON['nulabMixpanelId'] = mixpanel.nulab.get_distinct_id()
    }
    return formJSON;
  }

  submitForm(context, success, fail) {
    if (this.submitButton.hasClass('disable')) {
      return false;
    }

    this.recaptcha.check().then(() => {
      this.startButtonSpinner();
      const data = this.getFormData();
      cacoo.ajax({
        url: this.form.attr('action'),
        method: "POST",
        data: data,
        success: (data) => {
          if (!context) {
            this.submitForm_load(data);
          } else {
            success.call(context, data);
          }

        },
        error: (err) => {
          this.stopButtonSpinner();
          this.recaptcha.reset();

          if (context) {
            fail.call(context, err);
          } else {
            const response = err.responseJSON;
            if (response.errors) {
              switch (response.errors[0].field) {
                case 'password':
                  this.formMessageHandler.showError('password', response.errors[0].message);
                  break;
                default:
                  this.formMessageHandler.showError('default', response.errors[0].message);
                  break;
              }
            } else {
              this.formMessageHandler.showError('default', Cacoo.SiteResources['modal_signup_default_error']);
            }

            return false;
          }

        },
        timeout: 30000
      });
    }, () => {
      this.recaptcha.reset();
      this.stopButtonSpinner();
    })

  }

  submitForm_load(signupResponse) {
    if (!signupResponse.completionUrl) {
      //Unknow error
      this.stopButtonSpinner();
      this.formMessageHandler.showError('default', Cacoo.SiteResources['modal_signup_default_error']);
      this.recaptcha.reset();
      return false;
    }

    const completionUrl = new URL(signupResponse['completionUrl']);
    if (mixpanel.nulab && mixpanel.nulab.get_property('$device_id')) {
      // Attaching a Mixpanel ID to link events before and after signup to the same user (WEBDEV-3184)
      completionUrl.searchParams.append('mixpanel_device_id', mixpanel.nulab.get_property('$device_id'));
    }
    window.location.href = completionUrl.toString();
  }

  startButtonSpinner() {
    this.submitButton.addClass('disable');
    this.buttonSpinner.spin(this.submitButton.get(0));
  }

  stopButtonSpinner() {
    this.submitButton.removeClass('disable');
    this.buttonSpinner.stop();
  }

}
